import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAuditLogEntryReferenceDto } from '../../../../../../models/IAuditLogEntryReferenceDto';
import { LighthouseDashboardService } from '../../../../../../services/lighthouse-dashbaord/lighthouse-dashboard.service';
import { BaseComponent } from '../../../../../base/base.component';
import { IAuditTableQueryDto } from 'src/app/models/IAuditTableQueryDto';

@Component({
  selector: 'app-preview-data-modal',
  templateUrl: './preview-data-modal.component.html',
  styleUrls: ['./preview-data-modal.component.css']
})
export class PreviewDataModalComponent extends BaseComponent {
  constructor(private lighthouseDashboardService: LighthouseDashboardService) {
    super();
    let _ = this.Audit;
    this.tableName = this.PreviewDataTableName;
  }

  @Output() valueChange = new EventEmitter<boolean>();
  @Input() data: any = [];
  public tableData: Array<any> = [];
  public tableHeaders: Array<any> = [];
  skeleton:boolean = true;
  bodyskeleton:boolean = true;

  previewDataVisible: boolean = true;
  products!: Product[];
  public selectedLogEntryReference!: IAuditLogEntryReferenceDto;
  public showFilterModal: boolean = false;

  public gridShow: boolean = true;
  public tableName: string = '';
  public totalNumberOfEvents: number = 0;
  public logEntryReferences: Array<IAuditLogEntryReferenceDto> = [];

  messages: any;
  errorMessage:any;
  tableSortStates: Map<string, { column: string, direction: string }> = new Map();

  getPreviewDataProxy() {
    return Promise.resolve(this.getPreviewDataService().slice(0, 4));
  }

  getPreviewDataService() {
    return this.tableData;
  }

  override async ngOnInit() {
    //await this.getFakeData();
    await this.getPreviewData();
  }

  onDialogHide() {
    this.valueChange.emit(true);
  }

  private async getFakeData() {
    this.previewDataVisible = true;

    let headers: Array<any> = ['AuditType', 'AuditId', 'ModifiedBy', 'ModifiedDate'];

    for (var i = 0; i < 30; i++) {

      let b: Array<string> = [];

      for (var j = 0; j < 10; j++) {
        if (i == 0) {
          headers.push(`Column ${j}`);
        } else {
          b.push(`Value: row # ${i} + column: ${j}`);
        }
      }

      if (i === 0) {
        this.tableHeaders = headers;
        continue;
      }

      let a: any = {
        AuditType: 'I',
        AuditId: i,
        ModifiedBy: 'ModifiedBy',
        ModifiedDate: '11/05/2023',
        TableColumns: b
      }; // IAuditLogEntryReferenceDto // becuse when I get the
      // data back from the API it is PascalCase but when I console.log
      // it shows as camelCase.

      this.logEntryReferences.push(a);
    }

    console.log(this.logEntryReferences);
    this.totalNumberOfEvents = this.logEntryReferences.length;
  }

  private async getPreviewData() {
    let _1 = this.Audit;
    let _2 = this.PreviewDataTableSchema;
    let _3 = this.PreviewDataTableName;
    this.skeleton = false;
    await this.lighthouseDashboardService.getAuditTablePreviewDataAsync(_1.Id, _2, _3).then((x: Array<IAuditLogEntryReferenceDto>) => {
      x.map((z) => {
        this.data.push(z);
      });

      this.hydrateTableData();

      this.totalNumberOfEvents = this.logEntryReferences.length;

      this.previewDataVisible = true;
      this.bodyskeleton = false;
    }).catch((err: any) => {
      console.log(err);
      this.bodyskeleton = false;
    });
  }

  private getHeaders() {
    let headers2: Array<any> = [];
    let ss: any = [];

    let _: Array<any> = this.data;
    let ctr: number = 0;

    _.forEach((i) => {
      if (ctr === 0) {
        Object.keys(i).forEach(key => {
          let propertyName = key;
          if (propertyName === 'TableColumns') {
            let columns = i[key];
            // columns.forEach((x: any) => {
            //   headers2.push(x.Name);
            // });
            ss.push(columns);
          } else {
          
          if (propertyName === 'AuditType') headers2.unshift(propertyName);

           else headers2.push(propertyName);
          
          }
        });
        
        headers2 = ss?.length ? headers2.concat(ss[ctr].map((x: any) => x.Name)) : headers2;

        const indexCreated = headers2.findIndex(element => element === 'CREATED_BY_USER');
  
        if (indexCreated !== -1) {

          const reOrder = headers2.splice(indexCreated, 1)[0];
          headers2.splice(2, 0, reOrder);
         } 
         const indexCreatedDate = headers2.findIndex(element => element === 'CREATED_DATE');
         
         if (indexCreatedDate !== -1) {
          const reOrder2 = headers2.splice(indexCreatedDate, 1)[0];
          headers2.splice(3, 0, reOrder2);
         }

      }
      ctr += 1;
    });

    return headers2;
  }

  private hydrateTableData() {
    this.tableHeaders = this.getHeaders();
    this.logEntryReferences.push();

    for (var i = 0; i < this.data.length; i++) {

      this.data[i].TableColumns.push(
        { Name: "AuditType", Value: this.data[i].AuditType },
        { Name: "AuditId", Value: this.data[i].AuditId },
        { Name: "ModifiedBy", Value: this.data[i].ModifiedBy },
        { Name: "ModifiedDate", Value: this.data[i].ModifiedDate }
    );
           
              const reOrder = this.tableHeaders.map(header => {
                return this.data[i].TableColumns.find((item:any) => item.Name === header);
            }).filter(item => item !== undefined);
            
              this.data[i].TableColumns = reOrder;

      let a: any = {
        AuditType: this.data[i].AuditType,
        AuditId: this.data[i].AuditId,
        ModifiedBy: this.data[i].ModifiedBy,
        ModifiedDate: this.data[i].ModifiedDate,
        TableColumns: this.data[i].TableColumns
      }; // IAuditLogEntryReferenceDto // becuse when I get the
      // data back from the API it is PascalCase but when I console.log
      // it shows as camelCase.

      this.logEntryReferences.push(a);
    }
  }


  async applyFilter(event: any) {

    //put filter code/API here
  if (event.conditions[0].value) {
    
    this.messages = [{ severity: 'success', summary: 'Filter', detail: 'applied successfully' }];

}

  else{
    
    this.errorMessage = [
      { severity: 'error', summary: 'Invalid query!', detail: 'Check your filter logic!' },
  
    ];


    }
  
  }

  sortData(table: any, column: any) {
    let sortState = this.tableSortStates.get(table.name);

    if (!sortState || sortState.column !== column) {
      sortState = { column, direction: 'asc' };
    } else {
      sortState.direction = sortState.direction === 'asc' ? 'desc' : 'asc';
    }
    this.tableSortStates.set(table.name, sortState);
    if (column == "AuditType" || column == "AuditId" || column == "ModifiedBy" || column == "ModifiedDate") {
      table.data = this.sortTableData(table.data, sortState.column, sortState.direction);
    } else {
      table.data = this.sortTableDataDynamic(table.data, column, sortState.direction);
    }
  }

  sortTableData(data: any[], columnName: string, direction: string) {
    return data.sort((a, b) => {
      const valueA = a[columnName];
      const valueB = b[columnName];

      if (valueA === valueB) return 0;

      if (direction === 'asc') {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });
  }

  sortTableDataDynamic(data: any[], columnName: string, direction: string) {
    return data.sort((a, b) => {
      const valueA = a.TableColumns.find((col: any) => col.Name === columnName)?.Value;
      const valueB = b.TableColumns.find((col: any) => col.Name === columnName)?.Value;

      if (valueA === valueB) return 0;

      if (direction === 'asc') {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });
  }

  getSortIcon(table: any, column: string): string {
    const sortState = this.tableSortStates.get(table.name);

    if (sortState && sortState.column === column) {
      return sortState.direction === 'asc' ? 'pi-sort-up' : 'pi-sort-down';
    } else {
      return 'pi-sort';
    }
  }


}

export interface Product {
  id?: string;
  code?: string;
  name?: string;
  description?: string;
  price?: number;
  quantity?: number;
  inventoryStatus?: string;
  category?: string;
  image?: string;
  rating?: number;
}
